
import { Component, Prop, Vue } from "vue-property-decorator";
import { PrintGroup } from "@/models/PrintGroup";
import { getModule } from "vuex-module-decorators";
import PrintBasketModule from "../../../store/modules/PrintBasketModule";
import { PrintObject } from "@/models/PrintObject";
import { HandleDirective } from "vue-slicksort";
import { Helpers } from "@/global-scripts/helpers";

import $ from "jquery";

@Component({
  directives: {
    handle: HandleDirective,
  },
})
export default class PrintBasketGroup extends Vue {
  @Prop()
  list!: PrintGroup;

  readonly printBasketModule = getModule(PrintBasketModule, this.$store);

  collapsed = false;
  showWarning = false;

  get cssClass(): string {
    const classList = [];

    if (this.collapsed) {
      classList.push("collapsed");
    }
    
    return classList.join(" ");
  }

  removeItem(topic: PrintObject) {
    this.$tracker.trackPrintBasketEvent(`remove item`, window.location.href);

    this.printBasketModule.removeFromPrintBasket([topic]);
  }

  toggleCategory() {
    this.collapsed = !this.collapsed;
  }

  removeGroup(list: PrintGroup) {
    this.$tracker.trackPrintBasketEvent(`remove item`, window.location.href);
    this.printBasketModule.removeFromPrintBasket(list.topics);
  }

  itemCssClass(item: PrintObject): string {
    const classList = [];

    classList.push("type-topic");

    if (!item.inActiveFilter) {
      classList.push("not-in-filter");
    }

    return classList.join(" ");
  }

  hideWarningTooltiop() {
    this.showWarning = false;
  }

  showWarningTooltip() {
    if (Helpers.mobilecheck()) {
      this.showWarning = true;
    }
  }

  initKeyEvents() {
    $("body").click(function (event) {
      if (!$(event.target).closest("#openModal").length && !$(event.target).is("#openModal")) {
        $(".modalDialog").hide();
      }
    });
  }
}
